export default {
    //ProjectsList
    your_created_projects: "Ihre erstellten Kurse",
    new_project: "Neuer Kurs",
    search_course_placeholder: "Suchen Sie nach Ihrem Kurs...",
    projects_name: "KURS-NAME",
    update_at: 'Aktualisiert am ',
    coming_soon: 'Demnächst verfügbar',
    search_your_project: 'Suchen Sie nach Ihrem Kurs...',
    project_name: 'Name des Kurses',
    loading_projects: 'Projekte laden...',

    //ProjectEditComponent
    modify_project: 'Ändern Sie Ihren Kurs',
    general: 'Allgemein',
    access: 'Zugang',
    branding: 'Branding',
    product_page: 'Produkt Seite',
    sale: 'Verkauf',
    seo_text: 'SEO',
    product: 'Produkt',

    //CategoriesSlideOverComponent
    categories: 'Kategorien',
    text_category: 'Klassifizieren Sie Ihre Produkte nach Kategorien, um Ihren Studenten den Kauf Ihrer Kurse zu erleichtern.',
    select_category: 'Kategorie auswählen...',
    ebook: 'E-book',
    online_project: 'Online-Kurs',
    blended_learning: 'Blended Learning-Kurs',
    online_program: 'Online-Programm',
    webinar_consulting: 'Webinar / Online-Beratung',
    remove_category: 'Kategorie entfernen',
    href_help: 'Ich würde gerne mehr über die Kategorien erfahren',

    //ProjectEdit
    //CustomCategoriesComponent
    //GeneralComponent
    category: 'Kategorie',
    duration: 'Dauer',
    featured_product: 'Produkt-Spotlight',
    publish_project: 'Projekt veröffentlichen',
    delete_project: 'Projekt löschen',
    warning_delete: 'Warnung!',
    message_delete_project: 'Wenn Sie das Projekt löschen, gehen alle Daten unwiderruflich verloren.',
    question_delete_project: 'Sind Sie sicher, dass Sie dieses Projekt löschen wollen?',
    delete: 'Löschen',
    confirmation_delete_project: '(*) Dieses Feld ist erforderlich, um das Projekt zu löschen.',
    navigation: 'Navigation',
    navigation_free: 'Kostenlos',
    navigation_secuential: 'Sequentiell',
    navigation_without_restriction: 'Keine Einschränkungen. Der Nutzer kann frei durch den Kurs navigieren (ausgenommen Kurse mit Drip-Inhalten).',
    navigation_completed_restriction: 'Der Lernende muss jede Lerneinheit abschließen, bevor er mit der nächsten fortfahren kann. Der Abschluss von Lerneinheiten kann auf unterschiedliche Weise festgestellt werden.',
    quest_lesson_complete: 'Wann wird sie als abgeschlossene Lektion betrachtet?',
    lesson_complete_at_visit: 'Wenn besucht',
    lesson_at_visit_info: 'Wenn Sie eine Lektion eingeben, wird sie automatisch in den Gesamtfortschritt des Kurses eingefügt (Standardeinstellung).',
    lesson_complete_at_see: 'Bei vollständiger Anzeige des Inhalts',
    lesson_at_see_info: 'Sie wird als abgeschlossen markiert, wenn der Inhalt (Video, eBook, Podcast) vollständig angesehen wurde.',
    lesson_complete_on_time: 'Wenn Sie eine Weile bleiben',
    lesson_on_time_info: 'Auszufüllen durch Anwesenheit in jeder Unterrichtsstunde für die angegebene Zeit (HH:mm).',
    automatic_navigation: 'Automatische Navigation',
    automatic_navigation_disabled: 'Deaktiviert',
    automatic_navigation_enabled: 'Aktiviert',
    automatic_navigation_info: 'Wenn Sie den Inhalt einer Lektion abgeschlossen haben, gelangen Sie zur nächsten entsprechenden Lektion.',
    //PageComponent
    principal_page: 'Hauptseite',
    objects_presentation: 'Präsentation und Objekte',
    learning_objectives: 'Vergessen Sie nicht, die Lernziele kurz zu beschreiben.',
    teaching_staff: 'Methodik und Lehrpersonal',
    public: 'Öffentlich',
    content: 'Inhalt',
    sidebar: 'Seitenleiste',
    //ProductBrandingComponent
    banner: 'Banner',
    upload_banner: 'Laden Sie Ihr Banner hoch',
    banner_format: 'PNG, JPG, GIF bis zu 3 MB',
    promotional_video: 'Werbevideo',
    video_url: 'Video-URL',
    video_info: 'Wenn Sie ein Werbevideo haben, geben Sie hier die Url des Videos auf Youtube oder Vimeo an.',
    //SellComponent
    price_management: 'Preis-Management',
    sell_price: 'Verkaufspreis',
    tax: 'In €. (-3% Steuer)',
    price_offer: 'Angebotspreis',
    text_configuration: 'Text-Konfiguration',
    free_text_button: 'Freier Buy Button Titel',
    text_if_free: 'Dieser Titel erscheint, wenn Ihr Produkt kostenlos ist',
    on_sale: 'Zu verkaufen',
    sale_info: 'Wenn Ihr Produkt aktiviert ist, wird es zum Verkauf angeboten',

    //SeoComponent
    seo_configuration: 'SEO-Konfiguration',
    seo_title: 'SEO-Titel',
    slug: 'Slug',
    seo_description: 'SEO Beschreibung',

    //ProjectListComponent
    featured: 'Ausgewählt',
    classroom: 'Klassenzimmer',
    slug_text: 'slug',
    project: 'Projekt',
    projects: 'Projekte',
    preview: 'Vorschau',

    //ProjectAccessComponent
    access_project: 'Zugang zum Kurs',
    draft: 'Entwurf',
    draft_text: 'Dieses Projekt wird nicht in den Katalog aufgenommen und kann bearbeitet werden.',
    published: 'Veröffentlicht',
    published_text: 'Dieses Projekt ist veröffentlicht und die Benutzer können darauf zugreifen',
    private: 'Privat',
    private_text: 'Dieses Projekt ist privat, die Benutzer dieses Kurses werden sich manuell anmelden',
    coming_soon_access: 'Demnächst verfügbar',
    coming_soon_access_text: 'Dieses Projekt wird im Kurskatalog angezeigt, ist aber nicht zugänglich',
    enrollment_closed: 'Immatrikulation geschlossen',
    enrollment_closed_text: 'Nur eingeschriebene Benutzer können den Kurs betreten. Der Kurs wird im Katalog angezeigt, aber neue Benutzer können sich nicht einschreiben.',
    course_expiration: 'Ablauf des Kurses',
    project_expiration_info: 'Ihr Kurs ist während dieser Zeit zugänglich. Nach Ablauf dieses Zeitraums wird den angemeldeten Benutzern der Zugang zum Kurs verweigert.',
    init_date: 'Datum des Beginns',
    project_delete: 'Löschen',
    init_date_selected: 'Gewähltes Startdatum',
    end_date: 'Enddatum',
    date_delete: 'Löschen',
    end_date_selected: 'Ausgewähltes Enddatum',

    //ProjectContentComponent
    new_section: 'Neuer Abschnitt',
    section_title: 'Titel der Sektion: ',
    create_section: 'Abschnitt erstellen',
    import_section: 'Abschnitt "Importieren',
    lesson_title: 'Titel der Lektion:',
    new_lesson: 'Neue Lektion',

    //AttachProductSlideOverComponent
    attach_product_slide: 'Assoziiertes Produkt',
    selected_product: 'Ausgewähltes Produkt',
    quest_attach_product: 'Möchten Sie dieses Produkt anbringen?',

    //ProjectEditContentComponent
    back: 'Zurück',
    select_type_content: 'Wählen Sie die Art des Inhalts',
    type_lesson: 'Art der Lektion: ',
    html_editor: 'HTML-Editor',
    html_info_text: 'Fügen Sie den HTML-Code ein, den Sie in Ihrer Lektion anzeigen möchten',
    insert_video_url: 'Fügen Sie die URL des Videos ein',
    content_index: 'Inhaltsübersicht',
    student_list: 'Liste der Studenten',

    //ProjectLayoutContent
    image: 'Bild',
    classic_design: 'Klassischer Look',

    //Visibilidad staff (FE-001)
    edit_project: 'Kurs bearbeiten',

    //Listado de proyectos (FE-003)
    empty_projects_title: 'Noch keine Kurse vorhanden',
    empty_projects_text: 'Kurse dieser Akademie werden hier angezeigt.',
    export_students: 'Teilnehmer exportieren',
    unexpected_error: 'Ein unerwarteter Fehler ist aufgetreten',

    //Contenedor de edición (FE-005)
    loading_project: 'Kurs wird geladen...',

    //Secciones del contenido (FE-006)
    course_content: 'Kursinhalt',
    section_title_label: 'Titel des Abschnitts',
    section_title_placeholder: 'Z. B.: Einführung',
    section_title_required: 'Der Titel des Abschnitts ist erforderlich',
    section_created: 'Abschnitt erstellt',
    section_saved: 'Abschnitt gespeichert',

    //Estados vacíos y lecciones (FE-008)
    empty_sections_title: 'Dieser Kurs hat noch keinen Inhalt',
    empty_sections_text: 'Erstellen Sie einen Abschnitt, um Lektionen zu organisieren.',
    empty_lessons: 'Dieser Abschnitt hat noch keine Lektionen.',
    add_lesson: 'Lektion hinzufügen',
    lesson_title_label: 'Titel der Lektion',
    lesson_title_placeholder: 'Z. B.: Willkommen zum Kurs',
    lesson_title_required: 'Der Titel der Lektion ist erforderlich',
    lesson_created: 'Lektion erstellt',
    edit_lesson_content: 'Lektionsinhalt bearbeiten',

    //Pantalla de lección (FE-009)
    back_to_content: 'Zurück zum Inhalt',
    loading_lesson: 'Lektion wird geladen...',

    //Cabecera de lección con contexto (FE-053)
    lesson_breadcrumb: 'Position der Lektion im Kurs',
    section_n: 'Abschnitt {number}',
    lesson_n_of_total: 'Lektion {number} von {total}',
    previous_lesson: 'Zurück',
    next_lesson: 'Weiter',
    previous_lesson_named: 'Vorherige Lektion: {title}',
    next_lesson_named: 'Nächste Lektion: {title}',
    course_outline_short: 'Inhalt',
    course_outline: 'Kursinhalt',
    current_lesson: '(aktuelle Lektion)',
    rename_lesson_named: 'Lektion „{title}“ umbenennen',
    view_as_student: 'Als Student ansehen',
    opens_in_new_tab: '(öffnet in einem neuen Tab)',

    lesson_editing_coming_soon: 'Die Bearbeitung von Lektionsinhalten ist bald verfügbar.',

    //Adjuntar producto (FE-010)
    product_attached: 'Produkt mit dem Kurs verknüpft',
    product_detached: 'Produkt vom Kurs getrennt',

    //Pestaña General (FE-011)
    status_label: 'Status',
    general_editing_coming_soon: 'Das Bearbeiten der Kursdaten (Titel, Status, Löschen) ist bald verfügbar.',

    //Pestaña Acceso (FE-012)
    enrol_configuration: 'Einschreibungseinstellungen',
    enrol_configuration_empty: 'Klicken Sie auf die Schaltfläche, um eine Einschreibungskonfiguration zu erstellen. Die Teilnehmer beginnen und beenden ihre Einschreibung gemäß dieser Konfiguration.',
    enrol_configuration_create: 'Einschreibung konfigurieren',
    enrol_time_start: 'Startzeit',
    enrol_time_end: 'Endzeit',
    enrol_time_value: 'Menge',
    enrol_time_unit: 'Zeiteinheit',
    time_unit_hours: 'Stunden',
    time_unit_days: 'Tage',
    time_unit_weeks: 'Wochen',
    time_unit_months: 'Monate',
    time_unit_years: 'Jahre',
    enrol_configuration_invalid_value: 'Die Zeiten müssen ganze Zahlen größer oder gleich 0 sein',
    enrol_configuration_invalid_unit: 'Wählen Sie eine gültige Zeiteinheit',
    enrol_configuration_saved: 'Einschreibungseinstellungen gespeichert',
    enrol_configuration_deleted: 'Einschreibungseinstellungen gelöscht',

    //Textos del editor de contenido (FE-013)
    drag_section: 'Ziehen, um den Abschnitt neu anzuordnen',
    drag_lesson: 'Ziehen, um die Lektion neu anzuordnen',
    delete_section: 'Abschnitt löschen',
    delete_lesson: 'Lektion löschen',
    sections_order_saved: 'Reihenfolge der Abschnitte gespeichert',
    sections_order_error: 'Fehler beim Speichern der Abschnittsreihenfolge',
    lessons_order_saved: 'Reihenfolge der Lektionen gespeichert',
    lessons_order_error: 'Fehler beim Speichern der Lektionsreihenfolge',

    //Claves que faltaban respecto a es (FE-013)
    layout: 'Vorlage',
    attached_products: 'Verknüpfte Produkte',
    attach_product: 'Produkt verknüpfen',
    loading_attached_products: 'Verknüpfte Produkte werden geladen...',
    unattach_product: 'Produkt trennen',
    info_unattach_product: 'Wenn Sie das Produkt vom Kurs trennen, können Käufer dieses Produkts nicht mehr auf den Kurs zugreifen.',
    quest_unattach_product: 'Möchten Sie das Produkt wirklich trennen ',
    no_product_attached: 'KEINE VERKNÜPFTEN PRODUKTE',

    // FE-020 · Borrar secciones y lecciones
    delete_section_title: 'Abschnitt „{title}“ löschen?',
    delete_section_message: 'Der Abschnitt wird aus dem Kurs entfernt.',
    delete_section_with_lessons_message: 'Der Abschnitt enthält {count} Lektion(en), die ebenfalls gelöscht werden. Die Teilnehmenden sehen sie dann nicht mehr.',
    delete_lesson_title: 'Lektion „{title}“ löschen?',
    delete_lesson_message: 'Die Lektion und ihr Inhalt werden aus dem Kurs entfernt.',
    delete_confirm_button: 'Löschen',
    section_deleted: 'Abschnitt gelöscht',
    lesson_deleted: 'Lektion gelöscht',

    // FE-021 · Renombrar lecciones
    lesson_saved: 'Lektion gespeichert',

    // FE-022 · Reordenar y mover lecciones
    move_section_up: 'Abschnitt nach oben',
    move_section_down: 'Abschnitt nach unten',
    move_lesson_up: 'Lektion nach oben',
    move_lesson_down: 'Lektion nach unten',
    empty_lessons_drop: 'Dieser Abschnitt hat noch keine Lektionen. Füge eine hinzu oder ziehe eine aus einem anderen Abschnitt hierher.',

    // FE-023 · Publicar y vista previa gratuita
    status_published: 'Veröffentlicht',
    status_draft: 'Entwurf',
    publish_section: 'Abschnitt veröffentlichen',
    unpublish_section: 'Veröffentlichung des Abschnitts aufheben',
    publish_lesson: 'Lektion veröffentlichen',
    unpublish_lesson: 'Veröffentlichung der Lektion aufheben',
    section_published: 'Abschnitt veröffentlicht',
    section_unpublished: 'Abschnitt nicht mehr veröffentlicht: Teilnehmende sehen ihn nicht mehr',
    lesson_published: 'Lektion veröffentlicht',
    lesson_unpublished: 'Lektion nicht mehr veröffentlicht: Teilnehmende sehen sie nicht mehr',
    free_preview_badge: 'Vorschau',
    free_preview_enabled: 'Die Lektion ist jetzt eine kostenlose Vorschau',
    free_preview_disabled: 'Die Lektion ist keine kostenlose Vorschau mehr',

    //Editor de lección por bloques (FE-030)
    loading_blocks: 'Lektionsinhalt wird geladen...',
    drag_block: 'Ziehen, um den Block neu anzuordnen',
    move_block_up: 'Block nach oben',
    move_block_down: 'Block nach unten',
    delete_block: 'Block entfernen',
    block_type_not_editable: 'Dieser Blocktyp kann hier noch nicht bearbeitet werden.',
    add_block: 'Block hinzufügen',
    discard_changes: 'Änderungen verwerfen',
    blocks_load_error: 'Der Lektionsinhalt konnte nicht geladen werden',
    blocks_saved: 'Lektionsinhalt gespeichert',
    blocks_save_error: 'Fehler beim Speichern des Lektionsinhalts',
    block_type_rich_text: 'Text',
    block_rich_text_required: 'Der Textblock darf nicht leer sein',

    //Barra de guardado y estados del editor (FE-051)
    empty_blocks_title: 'Diese Lektion hat noch keinen Inhalt',
    empty_blocks_text: 'Fügen Sie einen Textblock, eine eingebettete Seite oder einen anderen Typ hinzu.',
    add_first_block: 'Ersten Block hinzufügen',
    blocks_status_dirty: 'Ungespeicherte Änderungen',
    blocks_status_saving: 'Wird gespeichert...',
    blocks_status_saved_at: 'Gespeichert um {time}',
    blocks_status_clean: 'Keine Änderungen',
    blocks_errors_count: '{count} Block mit Fehlern | {count} Block mit Fehlern | {count} Blöcke mit Fehlern',
    blocks_go_to_first_error: 'Zum ersten',
    save_shortcut_title: 'Speichern ({shortcut})',
    save_shortcut_hint: '{shortcut} zum Speichern',
    discard_confirm_title: 'Änderungen verwerfen?',
    discard_confirm_text: 'Die Lektion wird auf den zuletzt gespeicherten Stand zurückgesetzt.',

    //Guardado en lote del editor de bloques (FE-055)
    blocks_conflict_title: 'Jemand anderes hat diese Lektion gespeichert',
    blocks_conflict_text: 'Deine Änderungen sind noch auf dem Bildschirm. Wenn du neu lädst, siehst du die gespeicherte Version und verlierst, was du nicht gespeichert hast.',
    blocks_conflict_reload: 'Lektion neu laden',
    blocks_conflict_keep: 'Weiter bearbeiten',
    blocks_conflict_status: 'Jemand anderes hat diese Lektion gespeichert. Lade neu, um speichern zu können.',
    blocks_conflict_fallback: 'Jemand anderes hat diese Lektion gespeichert, während du sie bearbeitet hast.',

    //Insertar y manejar bloques (FE-052)
    block_actions: 'Blockaktionen',
    block_position: 'Block {position} von {total}',
    collapse_block: 'Block einklappen',
    expand_block: 'Block ausklappen',
    duplicate_block: 'Duplizieren',
    move_block_first: 'An den Anfang verschieben',
    move_block_last: 'An das Ende verschieben',
    insert_block_after: 'Block nach Block {position} einfügen',
    block_type_rich_text_description: 'Absätze, Überschriften, Listen, Links und Bilder.',
    block_type_embed_description: 'Formulare, Dokumente oder Präsentationen erlaubter Dienste.',
    block_type_video_description: 'Video von YouTube oder Vimeo.',
    block_type_quiz_description: 'Fragen mit automatischer Auswertung.',

    //Bloque de página embebida (FE-050)
    block_type_embed: 'Eingebettete Seite',
    block_embed_url_invalid: 'Geben Sie die vollständige Adresse der Seite ein, beginnend mit https://',
    block_embed_height_invalid: 'Die Höhe muss eine ganze Zahl zwischen 100 und 3000 Pixeln sein',
    block_embed_domain_not_allowed: 'Die Domain {host} darf nicht eingebettet werden',
    embed_url_label: 'Adresse der Seite',
    embed_url_placeholder: 'https://docs.google.com/forms/...',
    embed_url_help: 'Nur https-Seiten von erlaubten Diensten wie Google Forms, Google Docs, Microsoft Forms oder Slidebean.',
    embed_height_label: 'Höhe (Pixel)',
    embed_height_help: 'Zwischen {min} und {max}. Leer lassen, um die Standardhöhe zu verwenden.',
    embed_preview: 'Vorschau',
    embed_preview_title: 'Vorschau der eingebetteten Seite',
    embed_preview_after_save: 'Die Vorschau erscheint, sobald Sie die Lektion speichern.',

    //Bloque de imagen (FE-057)
    block_type_image: 'Bild',
    block_type_image_description: 'Ein Bild mit Alternativtext und optionaler Bildunterschrift.',
    block_image_required: 'Lade ein Bild für diesen Block hoch',
    block_image_alt_required: 'Gib den Alternativtext des Bildes ein',
    block_image_file_invalid: 'Das Bild ist nicht mehr verfügbar: Lade ein anderes hoch',
    image_choose: 'Bild auswählen',
    image_replace: 'Bild ändern',
    image_drop_hint: 'oder hierher ziehen',
    image_file_help: 'JPG, PNG, GIF oder WebP. Maximal {max} MB.',
    image_uploading: 'Bild wird hochgeladen... {progress} %',
    image_preview_unavailable: 'Die Bildvorschau kann nicht angezeigt werden.',
    image_type_invalid: 'Nicht unterstütztes Format: Verwende JPG, PNG, GIF oder WebP',
    image_too_large: 'Das Bild ist größer als {max} MB',
    image_upload_throttled: 'Du hast viele Bilder hintereinander hochgeladen. Warte eine Minute und versuche es erneut.',
    image_upload_error: 'Das Bild konnte nicht hochgeladen werden. Versuche es erneut.',
    image_alt_label: 'Alternativtext (Pflichtfeld)',
    image_alt_help: 'Beschreibe in einem Satz, was das Bild zeigt und warum es für die Lektion wichtig ist, zum Beispiel „Umsatzdiagramm, das 2025 jedes Quartal wächst“. Beginne nicht mit „Bild von“.',
    image_caption_label: 'Bildunterschrift (optional)',

    //Bloque de archivos descargables (FE-058)
    block_type_file: 'Herunterladbare Dateien',
    block_type_file_description: 'Dokumente oder andere Dateien zum Herunterladen für Lernende.',
    block_file_required: 'Lade mindestens eine Datei für diesen Block hoch',
    block_file_too_many: 'Dieser Block hat zu viele Dateien: entferne einige',
    block_file_invalid: 'Eine Datei ist nicht mehr verfügbar: entferne sie und lade sie erneut hoch',
    block_file_name_invalid: 'Der Anzeigename einer Datei ist zu lang (maximal 255 Zeichen)',
    file_empty: 'Dieser Block hat noch keine Dateien.',
    file_list_label: 'Dateien des Blocks ({count})',
    file_drag: 'Ziehen, um die Datei neu anzuordnen',
    file_open_new_tab: 'öffnet sich in einem neuen Tab',
    file_name_label: 'Anzeigename (optional)',
    file_move_up: 'Datei nach oben',
    file_move_down: 'Datei nach unten',
    file_remove: 'Datei entfernen',
    file_missing: 'Diese Datei ist nicht mehr verfügbar. Entferne sie aus dem Block.',
    file_unnamed: 'Datei ohne Namen',
    file_uploading: 'Wird hochgeladen... {progress} %',
    file_queued: 'Wartet',
    file_retry: 'Hochladen wiederholen',
    file_dismiss: 'Verwerfen',
    file_choose: 'Dateien auswählen',
    file_add_more: 'Weitere Dateien hinzufügen',
    file_drop_hint: 'oder hierher ziehen',
    file_limit_reached: 'Du hast das Maximum von {max} Dateien in diesem Block erreicht.',
    file_help: 'PDF, Word, Excel, PowerPoint, OpenDocument, RTF, TXT, CSV, ZIP, Bilder (JPG, PNG, GIF, WebP) oder MP3. Bis zu {max} MB pro Datei und {count} Dateien pro Block.',
    file_type_invalid: 'Format nicht unterstützt',
    file_too_large: 'Die Datei ist größer als {max} MB',
    file_too_many: 'Es passen keine weiteren Dateien hinein: maximal {max} pro Block',
    file_upload_throttled: 'Du hast viele Dateien hintereinander hochgeladen. Warte eine Minute und versuche es erneut.',
    file_upload_error: 'Die Datei konnte nicht hochgeladen werden. Versuche es erneut.',

    //Bloque de vídeo (FE-031)
    block_type_video: 'Video',
    block_video_required: 'Lade ein Video hoch oder füge einen YouTube- oder Vimeo-Link ein',
    video_source_label: 'Videoquelle',
    video_source_upload: 'Video hochladen',
    video_source_embed: 'YouTube- oder Vimeo-Link',
    video_uploaded: 'Video hochgeladen',
    video_upload_error: 'Fehler beim Hochladen des Videos',
    video_url_label: 'Videolink',
    video_url_placeholder: 'https://www.youtube.com/watch?v=...',
    video_url_help: 'Unterstützt YouTube-Links (auch Shorts und youtu.be) und Vimeo-Links.',
    video_preview: 'Vorschau',
    video_url_unsupported: 'Der Link ist kein gültiger YouTube- oder Vimeo-Link',
    video_url_error: 'Der Videolink konnte nicht geprüft werden',

    //Editor de quizzes (FE-033)
    block_type_quiz: 'Quiz',
    block_quiz_required: 'Erstelle das Quiz vor dem Speichern',
    quiz_empty: 'Dieser Block hat noch kein Quiz.',
    quiz_create: 'Quiz erstellen',
    quiz_default_title: 'Quiz',
    quiz_created: 'Quiz erstellt. Speichere die Lektion, um es in diesem Block zu behalten.',
    quiz_loading: 'Quiz wird geladen...',
    quiz_load_error: 'Das Quiz konnte nicht geladen werden',
    retry: 'Erneut versuchen',
    quiz_save_error: 'Fehler beim Speichern des Quiz',
    quiz_settings_saved: 'Quiz-Einstellungen gespeichert',
    quiz_title_label: 'Quiz-Titel',
    quiz_pass_percentage_label: 'Mindestpunktzahl zum Bestehen (%)',
    quiz_max_attempts_label: 'Maximale Versuche',
    quiz_unlimited: 'Unbegrenzt',
    quiz_max_attempts_help: 'Leer lassen für unbegrenzte Versuche.',
    quiz_required_to_progress: 'Muss bestanden werden, um fortzufahren',
    quiz_shuffle: 'Fragen und Antworten mischen',
    quiz_save_settings: 'Einstellungen speichern',
    quiz_title_required: 'Der Quiz-Titel ist erforderlich',
    quiz_pass_percentage_invalid: 'Die Mindestpunktzahl muss eine ganze Zahl zwischen 0 und 100 sein',
    quiz_max_attempts_invalid: 'Versuche müssen eine ganze Zahl größer als 0 sein',
    quiz_questions_title: 'Fragen ({count})',
    quiz_no_questions: 'Füge mindestens eine Frage hinzu.',
    quiz_add_question: 'Frage hinzufügen',
    quiz_edit_question: 'Frage bearbeiten',
    quiz_delete_question: 'Frage löschen',
    quiz_delete_question_title: 'Diese Frage löschen?',
    quiz_delete_question_text: 'Die Frage und ihre Antworten werden aus dem Quiz gelöscht. Dies kann nicht rückgängig gemacht werden.',
    quiz_question_saved: 'Frage gespeichert',
    quiz_question_deleted: 'Frage gelöscht',
    quiz_drag_question: 'Ziehen, um die Frage neu anzuordnen',
    quiz_move_question_up: 'Frage nach oben',
    quiz_move_question_down: 'Frage nach unten',
    quiz_order_error: 'Fehler beim Speichern der Fragenreihenfolge',
    quiz_remove_block_title: 'Quiz-Block entfernen?',
    quiz_remove_block_text: 'Beim Speichern der Lektion wird das Quiz mit seinen Fragen und den Versuchen der Lernenden gelöscht. Bis du speicherst, kannst du die Änderungen verwerfen, um es wiederherzustellen.',
    quiz_orphan_delete_error: 'Die Lektion wurde gespeichert, aber das Quiz eines entfernten Blocks konnte nicht gelöscht werden. Beim nächsten Speichern wird es erneut versucht.',
    quiz_statement_label: 'Fragetext',
    quiz_question_type_label: 'Fragetyp',
    quiz_type_single: 'Einfachauswahl',
    quiz_type_multiple: 'Mehrfachauswahl',
    quiz_options_label: 'Antworten',
    quiz_options_help_single: 'Markiere die einzige richtige Antwort.',
    quiz_options_help_multiple: 'Markiere alle richtigen Antworten.',
    quiz_correct: 'Richtig',
    quiz_option_text_label: 'Antwort {number}',
    quiz_option_feedback_label: 'Feedback bei Auswahl (optional)',
    quiz_add_option: 'Antwort hinzufügen',
    quiz_remove_option: 'Antwort entfernen',
    quiz_explanation_label: 'Erklärung (optional)',
    quiz_explanation_help: 'Wird dem Lernenden nach der Antwort angezeigt.',
    quiz_question_type_required: 'Wähle den Fragetyp',
    quiz_statement_required: 'Der Fragetext ist erforderlich',
    quiz_min_options: 'Füge mindestens zwei Antworten hinzu',
    quiz_option_text_required: 'Alle Antworten müssen Text enthalten',
    quiz_single_requires_one_correct: 'Markiere genau eine richtige Antwort',
    quiz_multiple_requires_correct: 'Markiere mindestens eine richtige Antwort',

    // FE-040 · Crear curso desde el panel
    new_course: 'Neuer Kurs',
    new_course_title: 'Kurs erstellen',
    new_course_text: 'Er wird als Entwurf erstellt. Danach kannst du Inhalte hinzufügen und die Kursdaten vervollständigen.',
    course_title_label: 'Kurstitel',
    course_title_placeholder: 'z. B.: Einführung in die Fotografie',
    course_title_required: 'Der Kurstitel ist erforderlich',
    create_course: 'Kurs erstellen',
    course_created: 'Kurs erstellt',

    // FE-041 · Editar la ficha del curso
    archived: 'Archiviert',
    course_details_loading: 'Kursdaten werden geladen...',
    course_subtitle_label: 'Untertitel',
    course_description_label: 'Beschreibung',
    course_cover_label: 'Titelbild',
    course_cover_alt: 'Titelbild des Kurses',
    course_cover_empty: 'Kein Titelbild',
    course_cover_help: 'Bild im Format 16:9 (empfohlen 1280×720), bis 5 MB.',
    course_cover_invalid: 'Wähle ein Bild mit höchstens 5 MB',
    course_slug_label: 'Sprechende URL (Slug)',
    course_slug_help: 'Nur Kleinbuchstaben, Zahlen und Bindestriche. Leer lassen, um ihn aus dem Titel zu erzeugen.',
    course_slug_invalid: 'Der Slug darf nur Kleinbuchstaben, Zahlen und Bindestriche enthalten',
    course_saved: 'Kursdaten gespeichert',

    // FE-042 · Duplicar y borrar curso
    duplicate_course: 'Kurs duplizieren',
    course_duplicated: 'Kurs dupliziert. Die Kopie ist ein Entwurf.',
    delete_course: 'Kurs löschen',
    delete_course_help: 'Der Kurs ist für die Teilnehmenden nicht mehr verfügbar. Diese Aktion kann im Panel nicht rückgängig gemacht werden.',
    delete_course_title: 'Diesen Kurs löschen?',
    delete_course_text: 'Der Kurs, seine Abschnitte und Lektionen werden gelöscht. Der Verlauf der Teilnehmenden bleibt erhalten.',
    delete_course_has_students: 'Dieser Kurs hat eingeschriebene Teilnehmende, die den Zugang verlieren. Bestätige erneut, um fortzufahren.',
    delete_course_confirmation_label: 'Gib zur Bestätigung den Kursnamen ein:',
    delete_course_force: 'Trotzdem löschen',
    course_deleted: 'Kurs gelöscht',

    // ProjectContentComponent · rediseño del editor de contenido
    sections_count: 'Keine Abschnitte | 1 Abschnitt | {count} Abschnitte',
    lessons_count: 'Keine Lektionen | 1 Lektion | {count} Lektionen',
    create_lesson: 'Lektion erstellen',
    section_number: 'Titel von Abschnitt {number}',
    edit_content: 'Bearbeiten',
    edit_lesson_content_of: 'Inhalt von „{title}“ bearbeiten',

    //Secciones plegables con resumen (FE-061)
    expand_all_sections: 'Alle ausklappen',
    collapse_all_sections: 'Alle einklappen',
    expand_section: 'Abschnitt „{title}“ ausklappen',
    collapse_section: 'Abschnitt „{title}“ einklappen',
    section_actions: 'Aktionen für Abschnitt „{title}“',
    lessons_published_count: 'keine veröffentlicht | 1 veröffentlicht | {count} veröffentlicht',

    //Programación (drip) dentro de la sección (FE-062)
    drip_menu: 'Zeitplan',
    drip_title: 'Zeitplan des Abschnitts',
    drip_help: 'Legen Sie fest, wann die Studierenden diesen Abschnitt sehen.',
    drip_immediate: 'Ab der Einschreibung verfügbar',
    drip_days_option: 'Einige Tage nach der Einschreibung',
    drip_days_label: 'Tage nach der Einschreibung',
    drip_days_suffix: 'Tage nach der Einschreibung',
    drip_date_option: 'An einem festen Datum',
    drip_date_label: 'Datum, ab dem er verfügbar ist',
    drip_days_invalid: 'Geben Sie eine ganze Zahl von Tagen zwischen {min} und {max} ein',
    drip_date_invalid: 'Wählen Sie ein gültiges Datum',
    drip_saved: 'Zeitplan des Abschnitts gespeichert',
    drip_badge_days: '{count} Tage nach der Einschreibung | 1 Tag nach der Einschreibung | {count} Tage nach der Einschreibung',
    drip_badge_date: 'Ab {date}',
    drip_edit_of: 'Zeitplan von „{title}“ bearbeiten: {schedule}',

    //Filas de lección simplificadas (FE-063)
    lesson_title_edit_hint: 'Zum Umbenennen klicken. Enter speichert, Escape macht rückgängig.',
    saved_inline: 'Gespeichert',
    free_preview_enable: 'Kostenlose Vorschau aktivieren',
    free_preview_enable_help: 'Alle Besucher können diese Lektion ohne Kauf des Kurses sehen.',
    free_preview_disable: 'Kostenlose Vorschau entfernen',
    lesson_actions: 'Aktionen für Lektion „{title}“',

    //Duplicar y acciones en lote (FE-065)
    duplicate_lesson: 'Duplizieren',
    duplicate_lesson_help: 'Die Kopie wird direkt darunter als Entwurf erstellt.',
    duplicate_section: 'Abschnitt duplizieren',
    duplicate_section_help: 'Kopiert den Abschnitt mit seinen Lektionen direkt darunter als Entwurf.',
    lesson_duplicated: 'Lektion dupliziert',
    section_duplicated: 'Abschnitt dupliziert',
    publish_section_with_lessons: 'Abschnitt und Lektionen veröffentlichen',
    unpublish_section_with_lessons: 'Veröffentlichung von Abschnitt und Lektionen aufheben',
    publish_section_with_lessons_title: '„{title}“ mit seinen Lektionen veröffentlichen?',
    unpublish_section_with_lessons_title: 'Veröffentlichung von „{title}“ mit seinen Lektionen aufheben?',
    publish_section_with_lessons_message: 'Der Abschnitt wird veröffentlicht. Alle Lektionen sind bereits veröffentlicht. | Der Abschnitt und {count} Lektion im Entwurf werden veröffentlicht. Die Lernenden können sie sehen. | Der Abschnitt und {count} Lektionen im Entwurf werden veröffentlicht. Die Lernenden können sie sehen.',
    unpublish_section_with_lessons_message: 'Die Veröffentlichung des Abschnitts wird aufgehoben. Keine Lektion ist veröffentlicht. | Die Veröffentlichung des Abschnitts und {count} veröffentlichten Lektion wird aufgehoben. Die Lernenden sehen sie nicht mehr. | Die Veröffentlichung des Abschnitts und {count} veröffentlichter Lektionen wird aufgehoben. Die Lernenden sehen sie nicht mehr.',
    section_with_lessons_published: 'Abschnitt und Lektionen veröffentlicht',
    section_with_lessons_unpublished: 'Veröffentlichung von Abschnitt und Lektionen aufgehoben',
    bulk_publish_partial_error: 'Kein Element konnte geändert werden | {count} Element konnte nicht geändert werden: Prüfe den Status und versuche es erneut. | {count} Elemente konnten nicht geändert werden: Prüfe den Status und versuche es erneut.',

    //Currículo en móvil (FE-064)
    rename_section: 'Abschnitt „{title}“ umbenennen',
    rename_lesson: 'Lektion „{title}“ umbenennen',
}
